const styles = (theme) => ({
  root: {
    padding: theme.spacing(1),
    marginRight: 6,
    '&.MuiCheckbox-indeterminate': {
      color: theme.color.black,
      width: 34,
      height: 34,
    },
  },
  icon: {
    width: 18,
    height: 18,
    border: `1px solid ${theme.color.grey_75}`,
    borderRadius: 2,
  },
  checkedIcon: {
    margin: -3,
  },
  disabled: {
    '& svg, & .MuiIconButton-label': {
      opacity: 0.34,
    },
  },
  label: {},
  labelRoot: {},
});

export default styles;
